import { createGlobalStyle, css } from 'styled-components';
import { repairSmithFieldOps } from 'utilities/getRepairSmithFieldOps';
import { tabletAndDesktop } from './resolution';
import { MAIN_FONT_COLOR, GRAY_F4 } from './colors';
import { DEFAULT_FONT_FAMILY } from './variables';

const { STATIC_URL_BASE } = repairSmithFieldOps;

const BodyStyles = createGlobalStyle`
  @font-face {
    font-family: 'Interstate';
    font-display: swap;
    src: url('${STATIC_URL_BASE}anms/fonts/Interstate-Regular.eot');
    src: url('${STATIC_URL_BASE}anms/fonts/Interstate-Regular.woff2')
    format('woff2'),
    url('${STATIC_URL_BASE}anms/fonts/Interstate-Regular.woff') format('woff'),
    url('${STATIC_URL_BASE}anms/fonts/Interstate-Regular.ttf') format('truetype');
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'Interstate-Light';
    font-display: swap;
    src: url('${STATIC_URL_BASE}anms/fonts/Interstate-Light.eot');
    src: url('${STATIC_URL_BASE}anms/fonts/Interstate-Light.woff2') format('woff2'),
    url('${STATIC_URL_BASE}anms/fonts/Interstate-Light.woff') format('woff'),
    url('${STATIC_URL_BASE}anms/fonts/Interstate-Light.ttf') format('truetype');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'Interstate-Bold';
    font-display: swap;
    src: url('${STATIC_URL_BASE}anms/fonts/Interstate-Bold.eot');
    src: url('${STATIC_URL_BASE}anms/fonts/Interstate-Bold.woff2') format('woff2'),
    url('${STATIC_URL_BASE}anms/fonts/Interstate-Bold.woff') format('woff'),
    url('${STATIC_URL_BASE}anms/fonts/Interstate-Bold.ttf') format('truetype');
    font-weight: 700;
    font-style: normal;
  }

  @font-face {
    font-family: 'Interstate-Black';
    font-display: swap;
    src: url('${STATIC_URL_BASE}anms/fonts/Interstate-Black.eot');
    src: url('${STATIC_URL_BASE}anms/fonts/Interstate-Black.woff2') format('woff2'),
    url('${STATIC_URL_BASE}anms/fonts/Interstate-Black.woff') format('woff'),
    url('${STATIC_URL_BASE}anms/fonts/Interstate-Black.ttf') format('truetype');
    font-weight: 900;
    font-style: normal;
  }

* {
  box-sizing: border-box;
}

html {
  position: relative;
  min-height: 100%;
  -webkit-font-smoothing: antialiased;
}

html,
body {
  max-width: 100%;
  font-family: ${DEFAULT_FONT_FAMILY};
  color: ${MAIN_FONT_COLOR};
}

body {
  overflow-x: hidden;
  background-image: radial-gradient(circle at 0 0, white, ${GRAY_F4});
  font-size: 13px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.6;
  letter-spacing: -0.1px;
}

h1,
h2,
h3,
h4,
h5 {
  font-weight: 700;
}

h1,
h2,
h3,
h4,
h5,
p,
body,
ul,
ol {
  margin: 0;
}

h1 {
  font-size: 30px;
  line-height: 1.17;
}

h2 {
  font-size: 24px;
  line-height: 1.1;
}

h3 {
  font-size: 20px;
  line-height: 1.1;
}

h4 {
  font-size: 16px;
  line-height: 1.1;
}

h5 {
  font-size: 14px;
  line-height: 1.21;
}

h6 {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.21;
}

${tabletAndDesktop(css`
  body {
    font-size: 15px;
  }

  h1 {
    font-size: 37.5px;
  }

  h2 {
    font-size: 30px;
  }

  h3 {
    font-size: 24px;
  }

  h4 {
    font-size: 20px;
  }

  h5 {
    font-size: 17px;
  }

  h6 {
    font-size: 17px;
  }
`)}

`;

export default BodyStyles;
